/**
 * Minimal role flags check – no dependencies, safe to use in Edge (e.g. middleware).
 * Shared with lib/utils/roles.ts so "has any admin role" logic lives in one place.
 */

export interface AdminRoleFlags {
  isAdmin?: boolean | null;
  isTeacher?: boolean | null;
  isStaff?: boolean | null;
  isChoreographer?: boolean | null;
}

/**
 * Returns true if any of the admin/teacher/staff flags is truthy.
 * Use from middleware (token) or from hasAnyAdminRole (user).
 */
export function hasAnyAdminRoleFromFlags(
  flags: AdminRoleFlags | null | undefined
): boolean {
  if (!flags) return false;
  return !!(
    flags.isAdmin ||
    flags.isTeacher ||
    flags.isStaff ||
    flags.isChoreographer
  );
}
